import { AppStore } from "@/core/data_sources/store/app";
import { AuthStore } from "@/core/data_sources/store/auth";

import { ErrorHandler } from "./error_handler";

ErrorHandler.addRegistry(401, (apply?: () => void) => {
  console.log("Unauthorized for the request");
  AuthStore.instance.actions.signOut().subscribe(() => {
    AppStore.instance.actions.clear();
    apply?.();
  });
});

export default ErrorHandler;
